import styled, { keyframes } from 'styled-components';

import { MobileDrawerBg } from './MobileStyles';

const modalPadding = '1.75rem';
const modalMobilePadding = '1.25rem';
const btnBgColor = 'var(--lolas-pacific-500)';
const btnBgLight = 'var(--lolas-clear-ocean-500)';
const btnColor = '#fff';
const mobHeaderHeight =
  document.querySelector('.tt-mobile-header').offsetHeight;

const SpinnerRotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100%{
        transform: rotate(360deg);
    }
`;

const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2rem 0 3rem 0;
  color: var(--lolas-blackcurrant-500);
  & h2 {
    font-weight: 700;
    font-size: 2.813rem;
    font-family: 'DM Sans';
    line-height: 3rem;
  }
  @media screen and (max-width: 576px) {
    margin: 1rem 0 2rem 0;
    & h2 {
      font-size: 2.188rem;
    }
  }
`;

const AvailableProduct = styled.div`
  display: grid;
  grid-template-rows: auto auto 30px;
  justify-content: center;

  & .cupcake-selector__available-product--price-title {
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
    margin-bottom: 0.5rem;

    & span {
      font-weight: 500;
      text-align: center;
      color: var(--lolas-blackcurrant-500);

      &:not(.available-product__price-title) {
        font-size: 0.725rem;
      }
      &.available-product__price-title {
        width: 200px;
        font-size: 0.938rem;
      }
    }
  }
`;

const AvailableProductImgFrame = styled.div`
  justify-self: center;
  position: relative;
  cursor: pointer;

  svg {
    position: absolute;
    top: 0;
    right: -1rem;
    cursor: pointer;

    circle {
      stroke: var(--lolas-blackcurrant-500);
    }

    path {
      fill: var(--lolas-blackcurrant-500);
    }
  }

  img {
    height: 165px;
  }

  &:hover, &.focused {
    svg {
      fill: var(--lolas-blackcurrant-500);
      & path {
        fill: #fff;
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0;
  }

  img {
    height: 120px;
  }
`;

const CupcakeSelectorBtn = styled.button`
  background-color: ${btnBgColor};
  border-radius: 30px;
  color: ${btnColor};
  border: none;
  font-weight: 500;
`;

const ShuffleBtn = styled(CupcakeSelectorBtn)`
  padding: 0 0.5rem;
  height: ${(props) => (props.$edit === true ? '50px' : '35px')};
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  justify-self: end;
  width: ${(props) => (props?.$edit === true ? '49%' : '125px')};
  & svg {
    margin-left: 0.5rem;
  }
`;

const RangeSelectorSwitch = styled.div`
  background-color: ${btnBgLight};
  width: 150px;
  height: 35px;
  border-radius: 30px;
  position: relative;
  cursor: pointer;

  &.mini-range {
    &::after {
      transform: translateX(100%);
    }
    span:nth-of-type(1) {
      color: ${btnBgColor};
      opacity: 0.5;
    }
    span:nth-of-type(2) {
      opacity: 1;
      color: #fff;
    }
  }

  &::after {
    transform: translateX(0);
    content: '';
    background-color: ${btnBgColor};
    height: 100%;
    width: 50%;
    border-radius: 30px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    transition: transform 0.25s cubic-bezier(1, 0, 0, 1);
  }

  span:nth-of-type(1) {
    color: #fff;
  }
  span:nth-of-type(2) {
    opacity: 0.5;
    color: ${btnBgColor};
  }

  span {
    font-weight: 700;
    font-size: 0.875rem;
    transition: opacity 0.25s ease, color 0.25s linear;
    height: 100%;
    width: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    position: relative;
  }

  @media screen and (max-width: 576px) {
    width: 145px;
  }
`;

const ProductSelectBtn = styled(CupcakeSelectorBtn)`
  width: 130px;
  height: 30px;
  font-size: 0.75rem;
  justify-self: center;
  background-color: var(--lolas-blackcurrant-500);
`;

const AddToSelectionQuantity = styled.div`
  width: 130px;
  height: 30px;
  color: #fff;
  text-align: center;
  display: flex;
  background-color: #efefef;
  border-radius: 30px;
  display: flex;
  justify-self: center;
  align-items: center;
  justify-content: space-between;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  span:nth-of-type(1),
  span:nth-of-type(3) {
    border-radius: 50%;
    background-color: var(--lolas-blackcurrant-500);
    cursor: pointer;
    color: #fff;
    width: 20px;
    height: 20px;
    font-weight: 500;
    font-size: 1rem;
    margin: 0 5px;
  }
  span:nth-of-type(2) {
    color: var(--lolas-blackcurrant-500);
    width: 40%;
    font-weight: 700;
    font-size: 1rem;
  }
`;

const CupcakeSelectorModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);

  & .inner {
    padding: ${modalPadding};
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    z-index: 11;
    position: relative;
    background-color: #fff;
    border-radius: 6px;
    overflow: hidden;
  }

  & .modal-close {
    position: absolute;
    right: ${modalPadding};
    top: ${modalPadding};
    font-weight: 500;
    font-size: 1.75rem;
    cursor: pointer;
    z-index: 11;
  }

  @media screen and (max-width: 576px) {
    & .inner {
      padding: ${modalMobilePadding};
    }
  }
`;

const BundleSizeBtn = styled.button`
  height: 35px;
  width: 35px;
  background-color: ${btnBgLight};
  border-radius: 50%;
  border: none;
  color: var(--lolas-pacific-300);
  font-weight: 700;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &.active {
    box-shadow: 0px 0px 0px 3px ${btnBgColor};
    color: ${btnBgColor};
  }
`;

const RangeSwitchPopup = styled(CupcakeSelectorModal)`
  & .inner {
    display: flex;
    justify-content: space-between;
    width: 475px;
    height: 280px;
    flex-direction: column;

    .modal-close {
      font-size: 2rem;
      top: 1rem;
      right: 1rem;
      font-weight: 400;
      color: ${btnBgColor};
    }

    h3 {
      color: ${btnBgColor};
      font-size: 1.5rem;
      text-align: center;
      margin-top: 1.5rem;
    }

    p {
      font-size: 0.8125rem;
      margin: 0;
    }

    div {
      display: flex;
      justify-content: space-between;
    }

    button {
      text-transform: uppercase;
      border: none;
      color: #fff;
      background: red;
      font-size: 0.9375rem;
      width: 49%;
      border-radius: 30px;
      height: 45px;
      cursor: pointer;
    }

    button:nth-of-type(1) {
      background-color: #48c566;
    }
    button:nth-of-type(2) {
      background-color: var(--lolas-pink-lemonade-500);
    }
  }

  @media screen and (max-width: 576px) {
    & .inner {
      width: 95vw;
      height: 260px;
    }
  }
`;

const PersonalisationErrorModal = styled(RangeSwitchPopup)`
  display: none;

  &.active {
    display: flex;
  }
  & .inner {
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-size: 1rem;
      text-align: center;
      font-weight: 500;
      color: ${btnBgColor};
    }
    button {
      width: 125px;
      height: 35px;
    }
  }
`;

const CupcakeInfoPopup = styled(CupcakeSelectorModal)`
  & .inner {
    padding: 0;
    background-color: var(--lolas-blush-100);
    color: var(--lolas-pink-lemonade-500);
    width: 750px;
    border: 1px solid var(--lolas-lavender-500);
    border-radius: 6px;
    border: 1px solid var(--lolas-pink-lemonade-500);
    display: grid;
    grid-template-areas:
      'toggles'
      'main';

    ${AddToSelectionQuantity} {
      background-color: #fff;
    }

    .wrapper-outer {
      overflow: hidden;
      grid-area: main;
    }

    .wrapper {
      display: grid;
      grid-template-columns: 100% 100% 100%;
      transition: transform 0.25s ease-in;
      transform: translate(
        ${(props) =>
          props.$activeTab === 'product'
            ? '0%'
            : props.$activeTab === 'nutritional'
            ? '-100%'
            : '-200%'}
      );
    }

    .inner__product-slider-section {
      padding: 1rem;
    }

    .inner__product-info {
      display: grid;
      height: 100%;

      .modal-close {
        top: 1rem;
        right: 1rem;
      }

      grid-template-areas:
        'img  description description description'
        'img  allergens allergens allergens'
        'composition composition composition composition';

      & .inner__product-info--desc {
        grid-area: description;

        h5 {
          font-weight: 700;
        }
      }

      & .inner__product-info--img {
        ${ProductSelectBtn}, ${AddToSelectionQuantity} {
          width: 75%;
        }
        grid-area: img;
        margin-right: 1rem;
        align-self: center;
        justify-self: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          height: 220px;
          margin-bottom: 0.75rem;
        }
      }

      & .product-info__ats-mobile {
        display: none;
      }

      & .allergens-disclaimer {
        grid-area: disclaimer;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 500;
        align-self: end;

        h6 {
          padding-bottom: 0.5rem;
        }
      }
      & .allergens {
        margin: 1.25rem 0;
        grid-area: allergens;

        h6 {
          text-transform: capitalize;
          font-weight: 700;
          font-size: 1.188rem;
          color: var(--lolas-pink-lemonade-500);
        }
        .allergen-tile {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 50px;
          }
          span {
            font-size: 0.875rem;
          }
        }
        & .cgtIcon img { 
            width: 100px;
        }
        .tvsIcon img {
          width: 130px;
        }
      }
        .allergens-section {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
      & .product-info__composition {
        grid-area: composition;
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0.75rem;
        margin-top: 1.5rem;
        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          background-color: #fff;
          height: 90px;
          max-height: 90px;
          padding: 10px;

          span {
            display: block;
            text-align: center;
            &:first-of-type {
              font-weight: 700;
              margin-bottom: 5px;
            }
          }
        }
      }
      & .product-info__composition:not(.quadrant) {
        div:nth-of-type(3) {
          grid-column: span 2;
        }
      }
    }

    .inner__product-nutrition {
      h5 {
        font-weight: 700;
      }
      .product-nutrition__nutritionals {
        .modal-close {
          position: relative;
          top: 0;
          right: 0;
          justify-self: end;
        }
        height: 100%;
        table {
          font-size: 0.938rem;
          width: 100%;
          height: 90%;
        }
        table th {
          font-weight: 400;
        }
        table tbody tr {
          &:nth-of-type(2n + 1) {
            background-color: var(--lolas-pink-lemonade-100);
          }
        }
      }
    }
  }

  .inner__product-ingredients h5,
  .inner__product-nutrition h5,
  .inner__product-info h5 {
    font-size: 1.563rem;
    font-weight: 700;
    color: var(--lolas-pink-lemonade-500) !important;
  }

  .inner__product-ingredients {
    .modal-close {
      position: relative;
      top: 0;
      right: 0;
      justify-self: end;
    }
    .product-ingredients__ingredient-list {
      margin-top: 5px;
      font-size: 0.813rem;
      & div {
        margin-top: 5px;
      }
    }
  }

  & .nav-toggles {
    grid-area: toggles;
    width: 100%;
    height: 55px;
    left: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;

    button {
      text-transform: uppercase;
      outline: none;
      border: none;
      height: 100%;
      font-weight: 600;
      font-size: 0.9rem;
      color: var(--lolas-pink-lemonade-500);
      background-color: var(--lolas-blush-300);
    }

    button:first-of-type {
      border-top-left-radius: 6px;
    }
    button:last-of-type {
      border-top-right-radius: 6px;
    }

    button:nth-of-type(2):not(.active) {
      border-right: 1px solid var(--lolas-pink-lemonade-500);
    }
    button:not(.active) {
      border-bottom: 1px solid var(--lolas-pink-lemonade-500);
    }

    button.active {
      background-color: var(--lolas-blush-100);
      border-left: ${(props) =>
        props.$activeTab === 'product' || props.$activeTab === 'ingredients'
          ? 'none'
          : '1px solid var(--lolas-pink-lemonade-500)'};

      border-right: ${(props) =>
        props.$activeTab === 'ingredients'
          ? 'none'
          : '1px solid var(--lolas-pink-lemonade-500)'};
    }
  }

  @media screen and (max-width: 768px) {
    & .inner {
      height: 100vh;
      width: 100vw;
      max-height: 100%;
      max-width: 100%;
      grid-template-areas:
        'main'
        'toggles';
      grid-template-rows: auto 55px;
      border: none;
      border-radius: 0;

      .wrapper-outer {
        overflow-x: hidden;
        overflow-y: auto;

        .inner__product-info {
          grid-template-areas:
            'img img img  img'
            'description description description description'
            'allergens allergens allergens allergens'
            'ats ats ats ats'
            'composition composition composition composition';

          .inner__product-info--desc {
            margin-top: 1.5rem;
            h5,
            p {
              text-align: center;
            }
          }
          .inner__product-info--img {
            margin-right: 0;
            ${ProductSelectBtn}, ${AddToSelectionQuantity} {
              display: none;
            }
          }
          .allergens {
            h6 {
              text-align: center;
            }
            .allergen-tile {
              img {
                width: 55px;
              }
            }
            .allergens-section {
              justify-content: center;
            }
            .cgtIcon img {
              width: 80px;
            }
            .tvsIcon img {
              width: 110px;
            }
          }
          .product-info__ats-mobile {
            grid-area: ats;
            display: flex;
            justify-content: center;
            align-items: center;
            ${ProductSelectBtn}, ${AddToSelectionQuantity} {
              height: 35px;
              width: 170px;
            }
          }
        }
        .product-info__composition {
          grid-template-columns: 1fr;
        }
        .product-info__composition:not(.quadrant) {
          div:nth-of-type(3) {
            grid-column: 1;
          }
        }
      }

      .product-nutrition__nutritionals {
        display: grid;
        grid-template-rows: 30px 80vh;
        table {
          margin-top: 0.75rem;
        }
      }

      .inner__product-ingredients {
        display: grid;
        grid-template-rows: 30px auto;
      }
      .inner__product-nutrition {
        grid-template-areas:
          'composition composition'
          'ingredients ingredients'
          'ingredients ingredients'
          'nutrition nutrition'
          'nutrition nutrition';
      }
      & .nav-toggles {
        button {
          font-size: 0.813rem;
          &:not(.active) {
            border-bottom: none;
            border-top: 1px solid var(--lolas-pink-lemonade-500);
          }
        }
      }
    }
  }
`;

const TotalTrackerContainer = styled.div`
  background-color: ${(props) => (!props.isMobile ? '#fff' : null)};
  border-radius: ${(props) => (!props.isMobile ? '30px' : null)};
  padding: ${(props) => (!props.isMobile ? '0 .75rem' : null)};
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  align-self: center;
  min-height: ${(props) => (props.$isMobile ? '50px' : '40px')};

  & h5 {
    font-size: 1.125rem !important;
    white-space: nowrap;
    font-weight: 700;
    text-transform: uppercase;
  }
  & .selection-total,
  & .selection-price {
    font-size: 1.125rem;
    text-transform: capitalize;
    color: ${btnBgColor};

    span {
      color: #e5426b;
    }
  }
  & .box-full.selection-total {
    span {
      color: #48c566;
    }
  }
`;

const tSwitchWidth = 25;
const tSwitchHeight = 15;

const ToggleSwitch = styled.div`
  height: ${tSwitchHeight}px;
  min-height: ${tSwitchHeight}px;
  width: ${tSwitchWidth}px;
  min-width: ${tSwitchWidth}px;
  border-radius: 30px;
  position: relative;
  background: #fff;
  cursor: pointer;

  &::after {
    content: '';
    border-radius: 50%;
    position: absolute;
    top: 50%;
    background: var(--lolas-silver-fox-500);
    width: ${tSwitchHeight - 5}px;
    height: ${tSwitchHeight - 5}px;
    transform: translate(2px, -50%);
    transition: all 0.25s ease;
  }

  &.active {
    background-color: ${btnBgColor};
  }

  &.active::after {
    transform: translate(${tSwitchWidth - (tSwitchHeight - 2)}px, -50%);
    background: ${btnBgLight};
  }
`;

const AddMsgWrapper = styled.div`
  background-color: var(--lolas-clear-ocean-500);
  width: 100%;
  display: grid;

  border-radius: 3px;
  transition: box-shadow 0.4s ease;
  padding: 1rem;
  margin-bottom: 1.5rem;

  h6 {
    color: ${btnBgColor};
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 0.5rem;
    grid-area: title;
  }

  p {
    color: ${btnBgColor};
    margin: 0;
    font-size: 0.938rem;
    text-align: justify;
  }

  &.activated {
    box-shadow: inset 0px 0px 0px 2px var(--lolas-pacific-500);
  }
  &.faded {
    opacity: 0.5;
  }
`;

const GFPackingInfo = styled.div`
  background-color: #fff;
  color: ${btnBgColor};
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 3px;
  margin-bottom: 1.5rem;

  h6 {
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  p {
    margin: 0;
    font-size: 0.938rem;
    text-align: justify;
  }
`;

const EditVibrateOne = keyframes`
  0% {
    transform: rotate(-1deg);
    animation-timing-function: ease-in;
  }
  50% {
    transform: rotate(1.5deg);
    animation-timing-function: ease-out;
  }
`;
const EditVibrateTwo = keyframes`
  0% {
    transform: rotate(.1deg);
    animation-timing-function: ease-in;
  }
  50% {
    transform: rotate(-1.5deg);
    animation-timing-function: ease-out;
  }
`;

const BgFlash = keyframes`
  0% {
    background-color: #fff;
  }
  40% {
    background-color: transparent;
  }
  1oo% {
    background-color: #fff;
  }
`;

const ProductImagePlaceholder = styled.div`
  aspect-ratio: 1/1;
  background-color: #fff;
  width: 100%;
  display: flex;
  align-self: center;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  justify-self: center;

  img:not(.empty-slot-img) {
    transition: opacity 0.35s ease-in-out;
    opacity: 0;
    width: 70%;
  }

  img:not(.empty-slot-img).fadeIn {
    opacity: 1;
  }
  img.empty-slot-img {
    width: 60%;
  }

  &.fade {
    opacity: 0.5;
  }
`;

const SelectionCells = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  grid-template-rows: auto;
  justify-content: center;
  margin-top: 0.5rem;
`;

const SelectionCell = styled.div`
  cursor: default;
  display: grid;
  grid-template-columns: 95%;
  grid-template-rows: auto 68px;
  position: relative;
  justify-content: center;

  input {
    border: none;
    padding: 0.75rem 0.5rem;
    border-radius: 3px;
    height: 40px;
    margin-top: 5px;
    color: var(--lolas-pacific-500);

    &::placeholder {
      color: var(--lolas-pacific-500);
      opacity: 0.5;
    }
  }

  input:focus-visible {
    outline: transparent;
  }

  &.focus ${ProductImagePlaceholder}, &.focus input {
    box-shadow: inset 0 0 0 1.5px var(--lolas-plump-plum-500);
  }

  &.product ${ProductImagePlaceholder} {
    cursor: pointer;
  }

  &:nth-of-type(2n) ${ProductImagePlaceholder}.editing img {
    animation-name: ${EditVibrateOne};
    animation-iteration-count: infinite;
    transform-origin: 50% 10%;
  }

  &:nth-of-type(2n-1) ${ProductImagePlaceholder}.editing img {
    animation-name: ${EditVibrateTwo};
    animation-iteration-count: infinite;
    transform-origin: 30% 5%;
  }

  & span {
    text-align: center;
    color: var(--lolas-pacific-500);
  }

  & span.fade {
    opacity: 0.5;
  }

  & .placeholder {
    aspect-ratio: 1/1;
    width: 100%;
    background-color: #fff;
  }

  @media screen and (max-width: 576px) {
    height: auto;
    justify-content: start;

    & ${ProductImagePlaceholder} {
      height: 120px;
    }
  }
`;

const SelectionItemRemove = styled.span`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  height: 25px;
  width: 25px;
  opacity: 0;
  z-index: 4;
  cursor: pointer;
  transition: opacity 0.25s linear;

  svg {
    width: 100%;
  }

  &:hover,
  ${ProductImagePlaceholder}:hover ~ & {
    opacity: 1;
  }

  @media screen and (max-width: 576px) {
    height: 18px;
    width: 18px;
    top: -0.25rem;
    right: 0.5rem;
  }
`;

const SelectorPrimaryBtn = styled.button`
  border: none;
  color: #fff;
  text-transform: uppercase;
  height: 50px;
  border-radius: 30px;
  padding: 0 1rem;
  font-size: 0.875rem;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const SelectionSaveBtn = styled(SelectorPrimaryBtn)`
  background-color: #48c566;
  width: 49%;
`;

const SelectionEdit = styled.span`
  font-weight: 700;
  white-space: nowrap;
  text-decoration: underline;
  text-transform: capitalize;
  color: ${btnBgColor};
  font-size: 0.875rem;
  display: block;
  margin: ${(props) => (!props.$rightAlign ? '0 auto' : null)};
  max-width: 200px;
  cursor: pointer;
  text-align: center;
`;

const PersonaliseInfo = styled.p`
  color: ${btnBgColor};
  font-weight: 700;
  font-size: 0.9375rem;
  display: block;
  margin: 0 auto;
  text-align: center;

  & span {
    color: #e5426b;
  }
`;

const BuyPersonaliseBtn = styled(SelectorPrimaryBtn)`
  background-color: ${(props) =>
    props.$showPersonalise && props.stage === 'review' && props.$isMobile
      ? 'var(--lolas-pacific-500)'
      : '#48C566'};
  width: 100%;
  transition: opacity 0.2s linear;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const pListImgDimension = 65;

const PersonalisationListItem = styled.div`
  width: 100%;
  display: grid;
  color: ${btnBgColor};
  grid-template-areas:
    'img title'
    'img input'
    'single-message single-message';

  margin: 0.75rem 0;
  padding: 0 0.5rem;
  position: relative;
  margin: 0.75rem 0 1.75rem;
  grid-template-rows: 1fr 1fr 30px;

  & .personalisation-item__img-container {
    margin-right: 0.75rem;
    height: ${pListImgDimension + 20}px;
    width: ${pListImgDimension + 10}px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    grid-area: img;
    justify-self: center;

    img {
      height: ${pListImgDimension}px;
    }
  }

  & span {
    grid-area: title;
    max-width: 175px;

    font-weight: 700;
    font-size: 0.8125rem;
  }

  & .personalisation-item__input-container {
    position: relative;
    align-self: end;
    grid-area: input;

    span {
      position: absolute;
      top: 55%;
      right: 0.5rem;
      transform: translateY(-55%);
      opacity: 0.5;
    }

    input {
      border: 1px solid transparent;
      background: transparent;
      border-bottom: 1px dashed ${btnBgColor};
      transition: border 0.25s linear;
      color: ${btnBgColor};
      width: 100%;
      height: 35px;
      padding-right: 32px;
      padding-left: 8px;

      &::placeholder {
        color: var(--lolas-pacific-500);
        opacity: 0.5;
      }

      &:focus,
      &:focus-visible {
        border: 1px solid var(--lolas-pacific-500);
        border-radius: 6px;
        outline: transparent;
      }
    }
  }
`;

const SingleMsgCheck = styled.div`
  display: flex;
  justify-content: ${(props) => (props.$isMobile ? 'end' : 'center')};
  margin-top: ${(props) => (props.$isMobile ? '.25rem' : '')};
  align-items: center;
  font-weight: 400;
  cursor: pointer;

  grid-area: ${(props) => (props.$isMobile ? 'single-message' : '')};

  & .single-msg-check__prompt {
    color: ${({ isMobile }) =>
      isMobile ? btnBgColor : 'var(--lolas-plump-plum-500)'};
    font-size: 0.875rem;
    display: inline-flex;
  }

  & .single-msg-check__checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 22.5px;
    width: 22.5px;
    border: 2px solid
      ${({ isMobile }) =>
        isMobile ? btnBgColor : 'var(--lolas-plump-plum-500)'};

    border-radius: 3px;
    background-color: #fff;
    margin-left: 0.25rem;

    svg {
      -webkit-backface-visibility: hidden;
      display: none;
      width: 100%;
    }
    path {
      stroke: ${({ isMobile }) =>
        isMobile ? btnBgColor : 'var(--lolas-plump-plum-500)'};
    }
    .active svg {
    }
  }
  & .single-msg-check__checkbox.active svg {
    display: block;
  }
`;

const PresetListToggle = styled.div`
  width: 100%;
  height: 45px;
  color: var(--lolas-pacific-500);
  background-color: #fff;
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 0 1rem;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  box-shadow: inset 0 0 0 1px var(--lolas-clear-ocean-500),
    inset 0 0 0 2px var(--lolas-clear-ocean-300);
  transition: box-shadow 0.4s ease;

  &.active {
    box-shadow: inset 0 0 0 1px var(--lolas-pacific-500),
      inset 0 0 0 2px var(--lolas-pacific-300);
  }

  &.active svg {
    transform: rotateX(0);
  }

  & svg {
    transition: transform 0.4s ease;
    transform: rotateX(180deg);

    path {
      stroke: var(--lolas-pacific-500);
    }
  }
`;

const PresetListContainer = styled.div`
  background-color: #fff;
  border-radius: 6px;
  position: absolute;
  width: 100%;
  z-index: 3;
  left: 50%;
  transform: translateX(-50%);
  top: 55px;
  display: none;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px var(--lolas-pacific-500),
    inset 0 0 0 2px var(--lolas-pacific-300);

  &.active {
    display: block;
  }

  & .ScrollbarsCustom-ThumbY {
    background-color: var(--lolas-pacific-500) !important;
  }

  & .ScrollbarsCustom-TrackY {
    width: 5px !important;
    right: 7.5px !important;
  }

  & ul {
    list-style: none;
    padding: 1rem;
    margin-bottom: 0;
  }
  & ul li {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--lolas-pacific-500);
    color: var(--lolas-pacific-500);
    height: 45px;
    font-size: 0.875rem;
  }
  & ul li:last-of-type {
    border-bottom: none;
  }

  @media screen and (min-width: 768px) {
    & ul li:hover {
      font-weight: 500;
    }
  }
`;

const SelectorLabel = styled.label`
  font-size: 0.813rem;
  padding: 0;
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: var(--lolas-pacific-500);
`;

const GridSection = styled.div`
  &.grid-right {
    background-color: var(--lolas-clear-ocean-300);
    color: var(--lolas-pacific-500);
    display: flex;
    flex-direction: column;
  }
`;

const ControlsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 70px 1fr;
  grid-template-rows: 1fr;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  align-self: center;
  @media screen and (max-width: 1230px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const StandaloneCharCount = styled.div`
  color: ${btnBgColor};

  & span {
    font-weight: 700;
  }
`;

const QuantityInput = styled.div`
  border-radius: 6px;
  height: 50px;
  display: flex;
  margin-right: 1rem;

  & button {
    border: none;
    outline: none;
    background-color: #48c566;
    color: #fff;
    width: 32px;
    font-size: 1.688rem;

    &:first-of-type {
      opacity: ${(props) => (props.$currentQuantity > 1 ? '' : '0.5')};
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    &:last-of-type {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
  & input {
    border: none;
    outline: none;
    width: 65px;
    text-align: center;
    color: #492b1f;

    &:focus-visible {
      outline: none;
      border: none;
    }
  }
`;

const SpinnerLoader = styled.span`
  height: ${(props) => (props.height ? `${props.height}px` : '')};
  width: X ${(props) => (props.width ? `${props.width}px` : '')};
  ${(props) =>
    props.vAlign
      ? props.vAlign === 'center'
        ? `top: 50%; transform: ${
            props.hAlign && props.hAlign === 'center'
              ? 'translate(-50%, -50%);'
              : 'translateY(-50%);'
          }`
        : props.vAlign === 'top'
        ? `top: 0;`
        : props.vAlign === 'bottom'
        ? `bottom: 0;`
        : null
      : null}
  ${(props) =>
    props.hAlign
      ? props.hAlign === 'center'
        ? `left: 50%; transform:  ${
            props.vAlign && props.vAlign === 'center'
              ? 'translate(-50%, -50%);'
              : 'translateX(-50%);'
          }`
        : props.hAlign === 'left'
        ? `left: 0;`
        : props.hAlign === 'right'
        ? `right: 0;`
        : null
      : null}
 & svg {
    animation: ${SpinnerRotate} 1.25s linear infinite;
    ${(props) => (props.delay ? `animation-delay: ${props.delay}ms;` : null)}
    circle {
      stroke-dasharray: 125;
      stroke-dashoffset: 0;
      transform-origin: center;
      stroke: ${(props) => (props.$stroke ? props.$stroke : '#000')};
    }
  }
`;

export {
  HeadingContainer,
  AvailableProduct,
  AvailableProductImgFrame,
  AddToSelectionQuantity,
  CupcakeInfoPopup,
  BundleSizeBtn,
  ProductSelectBtn,
  TotalTrackerContainer,
  SelectionCells,
  SelectionCell,
  AddMsgWrapper,
  GFPackingInfo,
  ToggleSwitch,
  BuyPersonaliseBtn,
  RangeSwitchPopup,
  RangeSelectorSwitch,
  ShuffleBtn,
  PersonalisationListItem,
  PresetListContainer,
  PresetListToggle,
  SelectorLabel,
  SelectionSaveBtn,
  SelectionEdit,
  PersonaliseInfo,
  PersonalisationErrorModal,
  GridSection,
  ControlsContainer,
  SelectionItemRemove,
  ProductImagePlaceholder,
  SingleMsgCheck,
  StandaloneCharCount,
  QuantityInput,
  SpinnerLoader,
};
